import styled from '@emotion/styled';

import Button from './Button';

const PhoneButton = styled(Button)({
  marginLeft: 16
});

export default PhoneButton;
